import React, { useEffect, useState, useMemo } from 'react';

const CodeLines = () => {
  const [lines, setLines] = useState([]);

  const codeSnippets = useMemo(() => [
    'def create_app():',
    'from fastapi import FastAPI',
    'async def process_data():',
    'class EmployeeManager:',
    'if __name__ == "__main__":',
    'import asyncio',
    'try: response = await db.query()',
    'return {"status": "success"}',
    'for item in collection:',
    'with open(file) as f:',
    '@app.route("/api/data")',
    'cursor.execute(query)',
    'session.commit()',
    'logger.info("Processing...")',
    'config = load_config()',
  ], []);

  useEffect(() => {
    const createLine = () => {
      const newLine = {
        id: Math.random(),
        text: codeSnippets[Math.floor(Math.random() * codeSnippets.length)],
        left: Math.random() * 100,
        duration: 10 + Math.random() * 10,
        delay: Math.random() * 5,
      };

      setLines((prev) => [...prev, newLine]);

      // Remove line after animation
      setTimeout(() => {
        setLines((prev) => prev.filter((line) => line.id !== newLine.id));
      }, (newLine.duration + newLine.delay) * 1000);
    };

    // Create new lines periodically - less frequent
    const interval = setInterval(createLine, 3000);
    
    // Create initial lines - fewer
    for (let i = 0; i < 3; i++) {
      setTimeout(createLine, i * 600);
    }

    return () => clearInterval(interval);
  }, [codeSnippets]);

  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-50">
      {lines.map((line) => (
        <div
          key={line.id}
          className="absolute text-green-400/20 dark:text-green-400/15 font-mono text-base font-semibold whitespace-nowrap animate-float-up"
          style={{
            left: `${line.left}%`,
            bottom: '-50px',
            animationDuration: `${line.duration}s`,
            animationDelay: `${line.delay}s`,
            textShadow: '0 0 5px rgba(74, 222, 128, 0.3)',
            mixBlendMode: 'screen',
          }}
        >
          {line.text}
        </div>
      ))}
    </div>
  );
};

export default CodeLines;